import * as React from "react";
import { Box, Typography } from "@mui/material";

/**
 * @function LayoutPublic
 * @description Layout se renderiza cuando no se pudo loguear el usuario
 * @returns {React.JSX.Element}
 */
export default function LayoutPublic (): React.JSX.Element {
    return (
        <Box
            display="flex"
            alignItems="center"
            justifyContent="center"
            sx={{
                width: "100vw",
                height: "100vh",
                overflow: "none",
                overflowY: "auto",
            }}
        >
            <Box
                borderRadius={3}
                borderColor="error.main"
                sx={{
                    width: "50vw",
                    padding: 2,
                    display: 'inline-block',
                    textAlign: "center",
                    margin:"auto",
                    borderStyle: "solid",
                    borderWidth: "1px",
                }}
            >
                <Typography variant="h1" gutterBottom>
                    Techint
                </Typography>
                <Typography variant="h3" gutterBottom>
                    Unregistered user
                </Typography>
                <hr color="error.main" />
                <Typography variant="h1" gutterBottom>
                    Error 401
                </Typography>
                <Typography variant="h4" gutterBottom>
                    Unauthorized
                </Typography>
            </Box>
        </Box>
    )
}
